const { default: types } = require("./types")

const INITIAL_STATE = {
    documentData: {},
    moveSelectedDocuments: null
}

const documentDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_DOCUMENT_DATA:
            return {
                ...state, documentData: action.documentData
            }
        case types.RESET_DOCUMENT_DATA:
            return {
                ...state, documentData: {}
            }
        case types.SET_MOVE_SELECTED_DOCUMENTS_DATA:
            return {
                ...state, moveSelectedDocuments: action.moveSelectedDocuments
            }
        default:
            return state
    }
}

export default documentDataReducer